import { useMemo } from 'react';
import { useData } from '../AdoptionData.jsx';
import { aggregate, avgWowRetention } from '../../../../lib/adoptionAnalytics.js';
import { sum, companySlug } from '../util.js';

export default function Companies() {
  const { events, aliases, setSelectedCompany } = useData();
  const agg = useMemo(() => aggregate(events, { aliases }), [events, aliases]);

  const rows = useMemo(() => {
    return agg.companies.map((c) => {
      const userDays = sum(agg.compUserDays[c]);
      const activeWeeks = agg.compUserDays[c].filter((v) => v > 0).length;
      const users = agg.users.filter((u) => agg.userCompany[u] === c);
      // per-company retention via filtered aggregate
      const sub = aggregate(events.filter((e) => agg.userCompany[e.user] === c), { aliases });
      const first = agg.weeks[agg.compUserDays[c].findIndex((v) => v > 0)];
      let lastIdx = -1;
      agg.compUserDays[c].forEach((v, i) => { if (v > 0) lastIdx = i; });
      return {
        company: c, slug: companySlug(c), userDays, activeWeeks,
        users: users.length, events: agg.compEvents[c] || 0,
        avgRet: Math.round(avgWowRetention(sub) * 100),
        first, last: lastIdx >= 0 ? agg.weeks[lastIdx] : null,
      };
    }).sort((a, b) => b.userDays - a.userDays);
  }, [agg, events, aliases]);

  if (!rows.length) return <div className="status">No companies in this snapshot.</div>;
  const maxUd = Math.max(1, ...rows.map((r) => r.userDays));

  return (
    <>
      <h1>Companies</h1>
      <p className="desc">{rows.length} companies · ranked by active user-days. Click a company for its per-user breakdown.</p>
      <div className="idxgrid">
        {rows.map((r) => (
          <button key={r.slug} type="button" className="idxcard" onClick={() => setSelectedCompany(r.company)}>
            <div className="nm">{r.company}</div>
            <div className="st">
              {r.users} users · {r.events} prompts<br />
              {r.userDays} active user-days · {r.activeWeeks} active weeks<br />
              Avg WoW retention {r.avgRet}% · {r.first} → {r.last}
            </div>
            <div className="bar"><i style={{ width: `${Math.round((100 * r.userDays) / maxUd)}%` }} /></div>
          </button>
        ))}
      </div>
    </>
  );
}
